import { useDispatch } from 'react-redux'
import UseDevicePixelRatio from '../../../../../common/hooks/useDevicePixelRatio'
import {
  conditionTargetInElement,
  getLayoutData,
} from '../../../../../common/panel/helper'
import classes from '../index.module.scss'
import { changeId } from '../store/slice'
import { decodeItemId } from './LayoutItem'

const LayoutContainer = ({ children }) => {
  const dispatch = useDispatch()
  const devicePixelRatio = UseDevicePixelRatio()

  const onDrop = (e) => {
    e.preventDefault()
    const dragId = e.dataTransfer.getData('childId')
    const dragEl = document.getElementById(dragId)
    const parentEl = e.target.closest('#parentId')
    const children = parentEl.children

    for (let index = 0; index < children.length; index++) {
      const child = children[index]
      if (conditionTargetInElement(e, child, devicePixelRatio)) {
        if (
          dragEl.getBoundingClientRect().top <
            child.getBoundingClientRect().top ||
          (dragEl.getBoundingClientRect().top ===
            child.getBoundingClientRect().top &&
            dragEl.getBoundingClientRect().left <
              child.getBoundingClientRect().left)
        ) {
          parentEl.insertBefore(dragEl, children[index + 1])
        } else {
          parentEl.insertBefore(dragEl, child)
        }
      }
    }

    dispatch(
      changeId(getLayoutData(parentEl).map((panel) => decodeItemId(panel.id))),
    )
  }

  const onDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <div
      id="parentId"
      onDrop={onDrop}
      onDragOver={onDragOver}
      className={`dFlex flexWrap ${classes.layoutParent}`}
    >
      {children}
    </div>
  )
}

export default LayoutContainer
